import { render, staticRenderFns } from "./RegistrationClosed.vue?vue&type=template&id=de571a4a&scoped=true&"
import script from "./RegistrationClosed.vue?vue&type=script&lang=js&"
export * from "./RegistrationClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de571a4a",
  null
  
)

export default component.exports